import { InjectionToken } from '@angular/core';
import { version } from '../../../../package.json';

/**
 * The Kundenportal version shown on the settings page: the web package.json version verbatim,
 * `-SNAPSHOT` included — it is also the image tag of every staging/main deploy (Readme, "Version
 * sync with ui_configs"), so what the customer reads is what runs.
 */
export const KUNDENPORTAL_VERSION: string = version;

/**
 * The same version in the comparable `major.minor.patch` form `KundenportalVersionService` holds
 * against the served `kundenportal` row — the suffix dropped the way bpp-stella drops it before
 * serving. A token so a spec can run the service against any bundle version.
 */
export const KUNDENPORTAL_BUNDLE_VERSION = new InjectionToken<string>('KUNDENPORTAL_BUNDLE_VERSION', {
  providedIn: 'root',
  factory: () => KUNDENPORTAL_VERSION.split('-')[0]
});
